import React from "react";
import './App.css';
import "animate.css/animate.min.css";
import 'bootstrap/dist/css/bootstrap.css';

import Rest from "./rest"
import myImage from './image/cv.png';
import { Container, Card, Row, Col, Button } from "react-bootstrap";

export default function HomeBody(){
    return(
        <div className="Home">
            <Container>
      
      <Row>

        <Col xs={12} md={6} lg={6} >

          <Card className="home-card" style={{backgroundColor: "black"}} >
            <Card.Img

              src={myImage} alt="MYIMAGE" className='myimage'> 
            </Card.Img>

          </Card>
          <hr className="hr" />

        </Col>
       
        <Col xs={12} md={6} lg={6} >
         
        <Container>
            <Card.Body className='body-text'>
            
              <Card.Title className='about-title'style={{color: "white", fontFamily: "serif", fontSize:20}}><b> I am Syma Afsha, a Pioneering Engineer and Visionary Researcher.</b> </Card.Title>
              <br/>
              
              <Card.Text className='about-text'> 
              I have recently graduated from the Erasmus Mundus Joint Masters program in Intelligent Field Robotic Systems (IFRoS), coordinated by the Universitat de Girona (UdG), Spain, in collaboration with the University of Zagreb (UNIZG), Croatia, and Eötvös Loránd University (ELTE), Hungary.

For the first two semesters, I attended courses at the Universitat de Girona (UdG), where I gained comprehensive knowledge and hands-on experience in Path Planning, Robot Localization, Robot Intervation, and Computer Vision. I continued my studies for the third semester at the Eötvös Loránd University (ELTE), further expanding my expertise and practical skills in Sensor Fusion, Deep Learning, Vehicle Senors, and AI. Moreover, I received my Bachelor of Science (B.Sc.) degree from the Department of Electrical, Electronic, and Communication Engineering (EECE) at the Military Institute of Science and Technology (MIST), Bangladesh. <br/>
                <br/>  I am passionate about advancing the field of robotics and contributing to the development of intelligent systems that can enhance human life.
              </Card.Text>

          <Rest/>
        
            </Card.Body>
            </Container>     
   
        </Col>

      </Row>
  
    </Container>
    <br/>

        </div>

    )
}